module.exports = __webpack_public_path__ + "img/clientelechannel.e7154028.svg";